import { TextField, type TextFieldProps } from '@mui/material';
import { memo, useCallback, useState } from 'react';

import type { ControlProps } from './SettingControl';

type T = ControlProps<string | number>;
export interface TextControlProps
  extends T, Omit<TextFieldProps, keyof T | 'onChange'> {
  type: 'string';
  onChange?: (value: string) => void;
}
export const TextControl = memo<Omit<TextControlProps, 'type'>>(
  ({ name, label, description, value, onChange }) => {
    const [val, setVal] = useState<string | number>(value ?? '');
    const handleBlur = useCallback(
      (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        onChange?.(event.target.value);
      },
      [onChange],
    );
    const handleChange = useCallback(
      (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setVal(event.target.value);
      },
      [],
    );
    return (
      <TextField
        fullWidth
        label={label || name}
        value={val}
        onChange={handleChange}
        onBlur={handleBlur}
        helperText={description}
      />
    );
  },
);

TextControl.displayName = 'TextControl';
